module.exports = __webpack_public_path__ + "assets/img/1.5add6023.png";